<footer class="footer" #footerSection>

  <!-- MIDDLE -->
  <div class="footer-main">

    <!-- LOCATION -->
    <div class="footer-section locations">
      <div class="location-item">
        <h6>Chennai</h6>
        <a href="tel:+919150896404">
          +91 9150 89 6404
        </a>
      </div>
    </div>

    <!-- EXPLORE -->
    <div class="footer-section links">

      <h3>Explore</h3>

      <ul>

        <li>
          <a
            href="#home"
            (click)="scrollTo('home'); $event.preventDefault()"
          >
            Home
          </a>
        </li>

        <li>
          <a
            href="#about"
            (click)="scrollTo('about'); $event.preventDefault()"
          >
            About
          </a>
        </li>

        <li>
          <a
            href="#services"
            (click)="scrollTo('services'); $event.preventDefault()"
          >
            Services
          </a>
        </li>

        <li>
          <a
            href="#work"
            (click)="scrollTo('work'); $event.preventDefault()"
          >
            Projects
          </a>
        </li>

        <li>
          <a
            href="#insights"
            (click)="scrollTo('insights'); $event.preventDefault()"
          >
            Insights
          </a>
        </li>

        <li>
          <a
            href="#contact"
            (click)="scrollTo('contact'); $event.preventDefault()"
          >
            Contact
          </a>
        </li>

      </ul>

    </div>

    <!-- CONNECT -->
    <div class="footer-section links">

      <h3>Connect</h3>

      <ul>

        <li>
          <a
            class="footer-link-button"
            href="https://www.linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            LinkedIn
          </a>
        </li>

        <li>
          <a
            class="footer-link-button"
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            Instagram
          </a>
        </li>

      </ul>

    </div>

  </div>

  <!-- BOTTOM -->
  <div class="footer-bottom">

    <div class="logo-video-box">
      <div class="footer-brand">
        MALKRIS
      </div>
    </div>

    <div class="legal-links">

      <button
        type="button"
        class="footer-link-button"
        (click)="openLegal('cookies')"
      >
        Cookie Policy
      </button>

      <button
        type="button"
        class="footer-link-button"
        (click)="openLegal('terms')"
      >
        Legal Notice & Terms
      </button>

      <button
        type="button"
        class="footer-link-button"
        (click)="openLegal('privacy')"
      >
        Privacy Policy
      </button>

    </div>

  </div>

</footer>

<!-- LEGAL MODAL -->
<app-legal-modal
  [activeDoc]="activeLegalDoc"
  (docChange)="openLegal($event)"
  (closed)="closeLegal()"
></app-legal-modal>